// extracted by mini-css-extract-plugin
module.exports = {"columnBackground":"TimetableSlots-module__columnBackground___3j1vm","column":"TimetableSlots-module__column___AUfVK","slotArea":"TimetableSlots-module__slotArea___3SIEu"};